import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class UnsoldDescriptionService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private unsoldDescriptionUrl = 'api/unsoldDescription';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getActiveUnsoldDescriptionList(): Promise<any> {
        let options = new RequestOptions({ headers: this.headers });
        return this.http
            .get(this.unsoldDescriptionUrl + '/getActiveUnsoldDescriptionList', options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getUnsoldDescriptionList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        return this.http
            .get(this.unsoldDescriptionUrl + '/getUnsoldDescriptionList', options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addUpdateUnsoldDescription(data: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in data) {
            params.set(key.toString(), data[key]);
        }
        let body = params.toString();
        let options = new RequestOptions({ headers: this.headers });

        return this.http
            .post(this.unsoldDescriptionUrl + '/addUpdateUnsoldDescription', body, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteUnsoldDescription(data: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in data) {
            params.set(key.toString(), data[key]);
        }
        let body = params.toString();
        let options = new RequestOptions({ headers: this.headers });

        return this.http
            .post(this.unsoldDescriptionUrl + '/deleteUnsoldDescription', body, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/unsoldDescription.service.ts